import { Result } from '@/core/models/Result';
import GlobalDataStorageFactory from '../factories/GlobalDataStorageFactory';

export default class MarkedAsFetchErrorGlobalDataUseCase {
    private globalDataStorageRepo = GlobalDataStorageFactory.makeRepo();

    public invoke() {
        const result = new Result<unknown>();

        this.globalDataStorageRepo.setIsFetchError(true);
        this.globalDataStorageRepo.markAsFetchedData();

        result.success = true;
        return result;
    }
}
